import DatabaseModel from './DatabaseModel.js';
import CacheService from './Cache.js';

var Formato = Object.create(DatabaseModel);

Formato.model = 'formato';
Formato.modelFront = 'formatos';

Formato.save= function(params) {
    var self = this;
    // Si hay documento es que tenemos que ir al importarComprobaciones
    if (params.data && params.data.documento) {
        return self.importarComprobaciones(params.data.documento);
    } else if (params.itemId) {
        return self.put(params);
    } else {
        return self.post(params);
    }
};

Formato.auditoria = function(params) {
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/auditoria',
        method: 'PUT',
        data: params.data
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};
Formato.predecir = function(id, datos) {
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + id + '/predecir',
        method: 'POST',
        data: datos
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

Formato.clonar = function(params){
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/' + params.newCode + '/duplica',
        method: 'GET',
        data: params.data
    };
    return self.sendRequest(params, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
}

Formato.exportarComprobaciones = function(formato){
    var self = this;
    return self.download(
        self.server_movilidad + self.prefix + self.model + '/' + formato.id + '/exportacomprobaciones', 
        formato.codigo + '.xlsx');
}
// Aquí estaba `regenerarCondicionesGPT`, retirado en la #995: escribía en el formato las reglas del
// modelo sin que nadie las revisara. Las reglas con IA llegan ahora como propuestas que decide una persona.
/**
 * Lotes en los que se trocea la generación del conjunto de condiciones de auditoría.
 */
Formato.lotesGeneracionCondiciones = function(idFormato){
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/condiciones/areas',
        method: 'GET'
    };
    return self.sendRequest(params, false);
}
// Aquí estaba `generarConjuntoCondiciones`, que generaba UNA sección y se llamaba en bucle desde
// la pantalla. Se ha quitado porque era la petición larga que la pasarela de producción cortaba:
// la sección salía en rojo aunque el motor la hubiera terminado y guardado. Ahora el barrido lo
// conduce el servidor (`lanzarGeneracionReglas`) y ninguna petición del navegador espera a los
// modelos. El endpoint sigue existiendo en movilidad como vía manual para una sección suelta.
/**
 * Lanza el barrido completo de generación de reglas EN SERVIDOR y vuelve enseguida.
 *
 * El progreso llega por SSE (canal 'generacion-reglas'), no por esta respuesta: así navegar,
 * recargar o cerrar la pestaña no corta el barrido, y al volver al formato se ve la situación
 * al día. Devuelve lanzado=false si ya había una pasada de ese formato en marcha.
 */
Formato.lanzarGeneracionReglas = function(idFormato, instrucciones, seccion){
    var self = this;
    // Solo se manda lo que tenga valor: un cuerpo con las claves vacías haría que el motor añadiera
    // un epígrafe de instrucciones en blanco al prompt de cada sección.
    var data = {};
    if (instrucciones && instrucciones.trim()) { data.instrucciones = instrucciones.trim(); }
    if (seccion) { data.seccion = seccion; }
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/condiciones/generacion',
        method: 'POST',
        data: data
    };
    return self.sendRequest(params, false);
}
/** Situación de la última pasada del formato, para pintar el cronograma al entrar. */
Formato.estadoGeneracionReglas = function(idFormato){
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/condiciones/generacion',
        method: 'GET'
    };
    return self.sendRequest(params, false);
}
/** Para la pasada: DETENER respeta lo generado, CANCELAR lo descarta. */
Formato.pararGeneracionReglas = function(idFormato, modo){
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/condiciones/generacion/parar',
        method: 'POST',
        data: { modo: modo }
    };
    return self.sendRequest(params, false);
}
/**
 * Cronograma de la generación: qué secciones están hechas, con su coste y sus reglas.
 * Es lo que permite pintar el estado al abrir el formato y retomar por donde se dejó.
 */
Formato.cronogramaIA = function(idFormato){
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/condiciones/cronograma',
        method: 'GET'
    };
    return self.sendRequest(params, false);
}
/** Borra el cronograma para volver a generar el formato entero desde cero. */
Formato.reiniciarCronogramaIA = function(idFormato){
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/condiciones/cronograma',
        method: 'DELETE'
    };
    return self.sendRequest(params, false);
}
/**
 * Propuestas generadas en pasadas anteriores que nadie ha aceptado ni descartado.
 * Sirve para recuperar una pasada que se cortó antes de guardar el formato.
 */
Formato.propuestasPendientesIA = function(idFormato, todas){
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/condiciones/propuestas'
            + (todas ? '?todas=true' : ''),
        method: 'GET'
    };
    return self.sendRequest(params, false);
}
/**
 * Marca propuestas como ACEPTADA o DESCARTADA para que no vuelvan a ofrecerse.
 */
Formato.resolverPropuestasIA = function(idFormato, textos, estado){
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/condiciones/propuestas/resolver',
        method: 'POST',
        data: { textos: textos || [], estado: estado }
    };
    return self.sendRequest(params, false);
}
Formato.switchPrecargas = function(idFormato){
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + idFormato + '/switchPrecargas', 
        method: 'GET'
    };
    return self.sendRequest(params, false);
}

Formato.importarComprobaciones = function(documento) {
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/importacomprobaciones',
        method: 'POST',
        data: documento
    };
    return self.sendRequest(params, false);
}

Formato.getVersion = function(params, forceReload) {
    var self = this;
    params = params || {};
    if (!params.itemId) reject({ error: 'itemId not defined' });
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId + '/version',
        method: 'GET',
        data: {}
    };
    return self.sendRequest(params, !forceReload);
};
/**
 * #1001 · Listado de revisión para la Dirección Técnica: formatos de prueba en uso, códigos
 * repetidos y en uso sin fecha de entrada en vigor. Solo lee; sin caché, para ver el estado actual.
 */
Formato.revisionCalidad = function() {
    const self = this;
    const params = {
        url: self.server_movilidad + self.prefix + self.model + '/revision-calidad',
        method: 'GET',
        data: {}
    };
    return self.sendRequest(params, false);
};

export default Formato;